var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"text-color":_vm.Colors.Chip.Text,"color":_vm.getOrderStatusColor(_vm.status)}},[_vm._v(" "+_vm._s(_vm.$t(_vm.getOrderStatusText(_vm.status)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }